/*
 * buy-with-variants.js
 *
 * Per-item option selectors for the "Complete your setup" rows.
 *
 * Each row is self-contained as of 2026-09-01: its own quantity box and its own
 * Add button, rather than a checkbox feeding the main product form. This script
 * keeps the row's <product-to-cart> pointed at whichever variant the selectors
 * currently describe, and keeps the displayed price and variant title in step.
 *
 * Without it the row would be stuck on first_available_variant no matter what
 * the customer chose.
 */
(() => {
    const SEL_ITEM = '[data-complementary-item]';
    const SEL_ADD = '[data-bw-add]';

    const formatMoney = (cents) => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents);
        }
        return '$' + (cents / 100).toFixed(2);
    };

    const sameOptions = (a, b) =>
        Array.isArray(a) &&
        a.length === b.length &&
        a.every((value, i) => value === b[i]);

    const initItem = (item) => {
        const data = item.querySelector('[data-bw-variants]');
        const $add = item.querySelector(SEL_ADD);
        if (!data || !$add) return;

        let variants;
        try {
            variants = JSON.parse(data.textContent);
        } catch (e) {
            return; // leave the server-rendered default in place
        }
        if (!Array.isArray(variants) || !variants.length) return;

        const selects = Array.from(item.querySelectorAll('[data-bw-option-index]'))
            .sort((a, b) => +a.dataset.bwOptionIndex - +b.dataset.bwOptionIndex);
        if (!selects.length) return;

        const $priceWrap = item.querySelector('[data-bw-price]');
        const $variantTitle = item.querySelector('[data-bw-variant-title]');
        const $unavailable = item.querySelector('[data-bw-unavailable]');
        const $button = $add.querySelector('[data-to-cart]');

        const setPrice = (cents) => {
            if (!$priceWrap) return;
            const $value = $priceWrap.querySelector('.\\#price-value') || $priceWrap;
            $value.textContent = formatMoney(cents);
        };

        const setDisabled = (state) => {
            item.classList.toggle('@unavailable', state);
            if ($button) $button.disabled = state;
            if ($unavailable) $unavailable.hidden = !state;
        };

        const apply = () => {
            const chosen = selects.map((s) => s.value);
            const variant = variants.find((v) => sameOptions(v.options, chosen));

            if (!variant) {
                // combination does not exist (e.g. 11 x 14 has no double-sided sign)
                setDisabled(true);
                return;
            }

            $add.setAttribute('variant-id', variant.id);
            setPrice(variant.price);
            if ($variantTitle) $variantTitle.textContent = variant.title;
            setDisabled(variant.available === false);
        };

        selects.forEach((s) => s.addEventListener('change', apply));
        apply(); // reconcile on load, in case the default combination is unavailable
    };

    const init = () => document.querySelectorAll(SEL_ITEM).forEach(initItem);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
